import CategoriesColumn from './CategoriesColumn';
import OptionsPane from './OptionsPane';
import OptionsPaneError from './OptionsPaneError';
import OptionsPaneLoading from './OptionsPaneLoading';
import SettingsFormHeader from './SettingsFormHeader';
import SubCategoriesColumn from './SubCategoriesColumn';
import { AnimationClassNames } from '@uifabric/styling';
import { observer } from 'mobx-react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Option, OptionSubCategory, SubCategoryState } from 'owa-options-core';
import { hideFullOptions, tryLoadAllFullOptionsSync } from 'owa-options-core';
import {
    getCurrentCategory,
    getCurrentSubcategory,
    getStore,
    getCurrentSubcategoryLoadState,
} from 'owa-options-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

@observer
export default class OptionsFull extends React.Component<{}, {}> {
    render() {
        let store = getStore();

        let subcategoriesForCategory: OptionSubCategory[] = getCurrentCategory().subcategories;
        let selectedSubCategory: OptionSubCategory =
            getCurrentSubcategory() || ({} as OptionSubCategory);
        let options: Option[] = tryLoadAllFullOptionsSync(selectedSubCategory);

        return (
            <Modal
                isOpen={store.isFullOptionsShown}
                onDismiss={this.hide}
                containerClassName={className(
                    store.isFullOptionsShown
                        ? AnimationClassNames.slideUpIn20
                        : AnimationClassNames.slideDownOut20,
                    styles.modal
                )}>
                <div className={styles.container}>
                    <CategoriesColumn />
                    <SubCategoriesColumn subcategories={subcategoriesForCategory} />
                    <div
                        className={className(
                            styles.settingsPane,
                            AnimationClassNames.slideLeftIn20
                        )}
                        role="tabpanel"
                        key={store.currentSubCategoryKey}>
                        <SettingsFormHeader selectedSubCategory={selectedSubCategory} />
                        {this.renderOptionsPane(options)}
                    </div>
                </div>
            </Modal>
        );
    }

    private hide() {
        hideFullOptions();
    }

    private renderOptionsPane(options: Option[]) {
        switch (getCurrentSubcategoryLoadState()) {
            case SubCategoryState.Loading:
                return <OptionsPaneLoading />;
            case SubCategoryState.Loaded:
                return options ? <OptionsPane options={options} /> : <OptionsPaneLoading />;
            case SubCategoryState.Error:
            default:
                return <OptionsPaneError />;
        }
    }
}

let optionsFullContainer: HTMLDivElement;

export function mountOptionsFullPopup() {
    if (!optionsFullContainer) {
        optionsFullContainer = document.createElement('div');
        document.body.appendChild(optionsFullContainer);

        ReactDOM.render(<OptionsFull />, optionsFullContainer);
    }
}
